import React from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@material-ui/core";

import TestEditorList from "./tests";
import Summary from "./summary";

import {Test, TestId} from "common/flowmaster/types/test";
import {WorkflowState} from "common/flowmaster/types/workflow_state";
import {LlmRunId, LlmRunTestResults} from "common/flowmaster/types/llm_run";
import {OrganisationId} from "common/types/organisation";

type Props = {
  llmRunId: LlmRunId;
  organisationId: OrganisationId;
  state: WorkflowState;
  tests: Test[];
  results?: LlmRunTestResults[];
  onClose: () => void;
  onAddTest: () => void;
  onUpdateTest: (
    id: TestId,
    type: string,
    value: Record<string, unknown>,
  ) => void;
  onDeleteTest: (id: TestId) => void;
};

export default function TestEditor({
  llmRunId,
  organisationId,
  state,
  tests,
  results,
  onClose,
  onAddTest,
  onUpdateTest,
  onDeleteTest,
}: Props) {
  return (
    <Dialog
      open={true}
      fullWidth={true}
      maxWidth="xl"
      PaperProps={{
        style: {height: "100%", display: "flex", flexDirection: "column"},
      }}
    >
      <DialogTitle>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <div>Workflow Tests</div>
          <DialogActions>
            <Button
              onClick={() => onAddTest()}
              color="primary"
              variant="contained"
            >
              Add
            </Button>
            <Button onClick={onClose} variant="contained">
              Close
            </Button>
          </DialogActions>
        </div>
      </DialogTitle>
      <Summary state={state} tests={tests} />
      <DialogContent>
        <TestEditorList
          llmRunId={llmRunId}
          organisationId={organisationId}
          tests={tests}
          results={results}
          onAddTest={onAddTest}
          onUpdateTest={onUpdateTest}
          onDeleteTest={onDeleteTest}
        />
      </DialogContent>
    </Dialog>
  );
}
